var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "sliderTestimonials",
      staticClass: "xl:absolute xl:top-[200px] xl:min-h-[600px] right-0 z-60"
    },
    _vm._l(_vm.localTestimonials, function(testimonial, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass:
            "xl:first:opacity-50 xl:last:opacity-50 xl:mb-50 testimonial-card"
        },
        [
          _c("div", { staticClass: "flex items-end gap-50 " }, [
            _c(
              "div",
              {
                staticClass: "hidden xl:flex flex-col",
                class: {
                  "order-3": index % 2 !== 0,
                  "text-right": index % 2 === 0
                }
              },
              [
                _c("span", { staticClass: "text-white" }, [
                  _vm._v(
                    _vm._s(_vm._f("moment")(testimonial.post_date, "DD-MM-Y"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "text-brown-400 text-22 font-bold" },
                  [_vm._v(_vm._s(testimonial.post_title))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "text-brown-400" }, [
                  _vm._v(_vm._s(testimonial.acf.company))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "h-[300px] xl:h-auto order-2 bg-white p-32 w-[515px]  text-left text-20 font-regular relative ",
                class: { "xl:pl-[140px]": !testimonial.acf.image },
                staticStyle: { "line-height": "30px" }
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "text-orange italic absolute top-32 left-8  hidden xl:block",
                    class: {
                      "text-[115px] top-[36px] left-[-12px]":
                        testimonial.acf.image,
                      "top-32 left-8 text-200": !testimonial.acf.image
                    }
                  },
                  [_vm._v("“")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-row items-center gap-[16px] " },
                  [
                    testimonial.acf.image
                      ? _c("img", {
                          staticClass: "w-[60px]",
                          class: { grayscale: !!_vm.bw },
                          attrs: { src: testimonial.acf.image, alt: "" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-clamp", {
                      staticClass: "text-16 leading-snug rte noleading-m",
                      attrs: { "max-lines": 5 },
                      domProps: {
                        innerHTML: _vm._s(testimonial.acf.description)
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col xl:hidden pt-16" }, [
                  _c(
                    "span",
                    { staticClass: "text-brown-400 text-22 font-bold" },
                    [_vm._v(_vm._s(testimonial.post_title))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-brown-400" }, [
                    _vm._v(_vm._s(testimonial.acf.company))
                  ])
                ])
              ]
            )
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }